import { NAME } from './constants';
import { router } from './router';
import { apiProvider } from './api';

export const WorkInProgress = {
	name: NAME,
	router,
	apiProvider,
};
